import React, { useState } from 'react';
import { ReactComponent as CloseIcon } from '../../Icons/close.svg';
import '../../Styles/Contact/ChatModal.css';
import sendMail from '../../Utils/EmailJS';

const initState = {
    Name: "",
    Email: "",
    Message: ""
}

const ChatModal = ({ toggleShowChatModal }) => {
    const [query, setQuery] = useState(initState);
    const [messageStatus, setMessageStatus] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setQuery({ ...query, [name]: value })
    }

    const handleSubmitForm = (e) => {
        e.preventDefault();

        sendMail(e);

        setQuery(initState);
        setMessageStatus(true);
    }

    return (
        <React.Fragment>
            <div className="chat-model-main-container flex-box">
                <h1 className="chat-model-heading-box">Leave Message</h1>
                <div className="chat-model-close-icon flex-box" onClick={toggleShowChatModal}>
                    <CloseIcon />
                </div>
            </div>
            <div className="chat-model-form-container-wrapper">
                <div className="flex-box">
                    <h3>Wanna build, Call: 7975537812</h3>
                </div>
                <div className="chat-model-form-container flex-box">
                    <form className="flex-box chat-model-form" onSubmit={handleSubmitForm}>
                        <div className="flex-box" style={{ display: `none` }}>
                            <input value={`${query.Name} texted you.`} name="Subject" onChange={handleChange} />
                        </div>
                        <label>Name</label>
                        <div className="flex-box">
                            <input value={query.Name} name="Name" autoFocus onChange={handleChange} required type="text" placeholder="What to call you?" />
                        </div>
                        <label>Email</label>
                        <div className="flex-box">
                            <input value={query.Email} name="Email" onChange={handleChange} required type="email" placeholder="Please give me your mail id..." />
                        </div>
                        <label>Message</label>
                        <div className="flex-box">
                            <textarea value={query.Message} name="Message" onChange={handleChange} required placeholder="I'll take your message..."></textarea>
                        </div>
                        {
                            messageStatus && (
                                <div className="chat-success-message flex-box">
                                    <span>Thank you for messaging, Will reply soon.</span>
                                    <i className="fa fa-check"></i>
                                </div>
                            )
                        }
                        <div className="divider"></div>
                        <div className="chat-form-submit-button-wrapper flex-box">
                            <button className="flex-box chat-form-submit-button" onSubmit={handleSubmitForm}>
                                <span>Send</span>
                                <i className="fa fa-paper-plane"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ChatModal
